import { useTranslation } from 'store/dictionary/selectors';

export const Text = ({ k }) => {
    return useTranslation(k);
};
